import React from "react";
import { cn } from "@/lib/utils";
import { AlertTriangle, Info, ShieldAlert, CheckCircle2 } from "lucide-react";

const LEVELS = {
  danger: {
    cls: "border-destructive/50 bg-destructive/10",
    icon: ShieldAlert,
    iconCls: "text-destructive",
    title: "Rischio elevato",
  },
  warning: {
    cls: "border-amber-500/40 bg-amber-500/10",
    icon: AlertTriangle,
    iconCls: "text-amber-400",
    title: "Attenzione",
  },
  info: {
    cls: "border-sky-500/40 bg-sky-500/10",
    icon: Info,
    iconCls: "text-sky-400",
    title: "Suggerimento",
  },
};

export const RiskWarnings = ({ warnings = [] }) => {
  const ordered = ["danger", "warning", "info"];
  const sorted = [...warnings].sort(
    (a, b) => ordered.indexOf(a.level) - ordered.indexOf(b.level)
  );

  return (
    <div data-testid="risk-warnings-panel" className="space-y-2">
      {sorted.length === 0 ? (
        <div className="flex items-start gap-2 rounded-md border border-[hsl(var(--primary))]/40 bg-[hsl(var(--primary))]/10 p-3">
          <CheckCircle2 className="h-4 w-4 text-[hsl(var(--primary))] mt-0.5 shrink-0" />
          <div>
            <div className="text-sm font-medium text-[hsl(var(--primary))]">[ OK ] Configurazione coerente</div>
            <div className="text-xs text-muted-foreground">Nessun avviso di rischio rilevato.</div>
          </div>
        </div>
      ) : (
        sorted.map((w, i) => {
          const lv = LEVELS[w.level] || LEVELS.info;
          const Icon = lv.icon;
          return (
            <div
              key={`${w.field}-${i}`}
              data-testid="risk-warning-item"
              role={w.level === "danger" ? "alert" : undefined}
              className={cn("flex items-start gap-2 rounded-md border p-3", lv.cls)}
            >
              <Icon className={cn("h-4 w-4 mt-0.5 shrink-0", lv.iconCls)} />
              <div className="min-w-0">
                <div className="text-sm font-medium text-foreground">{lv.title}</div>
                <div className="text-xs text-muted-foreground leading-relaxed">{w.message}</div>
              </div>
            </div>
          );
        })
      )}

      <div className="rounded-md border border-border bg-muted/40 p-3 text-xs text-muted-foreground leading-relaxed">
        &gt; Esegui sempre test su <span className="font-medium text-[hsl(var(--primary))]">conto demo</span> e
        ottimizza i parametri con il backtester di cTrader su almeno 2 anni di dati XAUUSD prima dell'uso reale.
      </div>
    </div>
  );
};
